import { Grid, Spin, Typography } from "antd";
import { DocumentoService } from "../Services/Domain/Documentos/DocumentoService";
import { useQuery } from "@tanstack/react-query";


type PreviewProps = { data: Blob, mimetype?: string }
export const Preview = (props: PreviewProps) => {
    const {data, mimetype} = props;
    const breakpoint = Grid.useBreakpoint();
    
    const blob = new Blob([data], { type: mimetype });
    const url = URL.createObjectURL(blob);

    let cssProps: React.CSSProperties = {}

    if(mimetype?.startsWith("image")){
        
    }
    else if(mimetype?.startsWith("video")){
        cssProps = { width: "100%", height: "auto" };
    } else if(mimetype == "application/pdf"){
        cssProps = { width: "100%" }; 
    }

    if (data && mimetype) {
        return <object data={url} type={mimetype} style={{ width: "100%", minHeight: "70vh", ...cssProps }}></object>;
    }

    return <Typography.Title level={4}>Nenhuma prévia disponível</Typography.Title>;
};

const PeloGUID = (props: {nomeGUID: string} ): JSX.Element => {
    const query = useQuery({
        queryKey: ["DocumentoService.obterArquivo", props.nomeGUID],
        queryFn: () => DocumentoService.obterArquivo(props.nomeGUID)
    })

    const blob = query.data?.data;
    const mimetype = query.data?.headers["content-type"] as string | undefined;

    return (
        <Spin spinning={query.isFetching}>
            {blob && 
                <Preview data={blob} mimetype={mimetype} />
            }
        </Spin>
    );
}

Preview.PeloGUID = PeloGUID;